import React from 'react';
import './Table.css';

export function Table({ children, className = '' }) {
    return (
        <div className={`table-wrapper ${className}`}>
            <table className="ui-table">
                {children}
            </table>
        </div>
    );
}

export function TableHead({ children }) {
    return <thead>{children}</thead>;
}

export function TableBody({ children }) {
    return <tbody>{children}</tbody>;
}

export function TableRow({ children, className = '', ...props }) {
    return <tr className={`ui-table-row ${className}`} {...props}>{children}</tr>;
}

export function TableHeader({ children, className = '', ...props }) {
    return <th className={`ui-table-header ${className}`} {...props}>{children}</th>;
}

export function TableCell({ children, className = '', ...props }) {
    return <td className={`ui-table-cell ${className}`} {...props}>{children}</td>;
}
